export default "__VITE_ASSET__Cueua70F__"